/**
 * @file 教师上课端入口
 * 装配顺序：错误边界 → 运行时（api-client + 会话）→ Toast → 路由。
 * 组件本身不发起任何 HTTP 请求，全部经 runtime.api（规范 4.4）。
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import {
  ErrorBoundary,
  GlobalErrorBridge,
  RuntimeProvider,
  ToastProvider,
  createAppRuntime,
} from '@lexiloop/shared';
import '@lexiloop/shared/tokens.css';
import '@lexiloop/shared/styles.css';
import { App } from './App';

/** 运行时单例：clientType 决定 X-Client-Type 与 refresh token 的存储键。 */
const runtime = createAppRuntime({ clientType: 'teacher', appName: '教师上课端' });

const container = document.getElementById('root');
if (!container) throw new Error('未找到 #root 挂载点');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <RuntimeProvider runtime={runtime}>
        <ToastProvider>
          <GlobalErrorBridge />
          {/* basename 跟随构建 base：同域部署可用 /admin/、/crm/ 前缀，独立部署时仍为 / */}
          <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '') || '/'}>
            <App />
          </BrowserRouter>
        </ToastProvider>
      </RuntimeProvider>
    </ErrorBoundary>
  </StrictMode>,
);
